import { motion } from "framer-motion";
import { LOGO } from "@/data/logoData";

export default function BrandLoader() {
  return (
    <motion.div
      data-testid="brand-loader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0B0F19]"
      exit={{ y: "-100%", transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] } }}
    >
      <motion.div
        initial={{ scale: 0.85, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="rounded-3xl bg-white px-8 py-6 shadow-2xl shadow-brand/20"
      >
        <img src={LOGO} alt="Bigboss Digitech" className="h-16 w-auto object-contain sm:h-20" />
      </motion.div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, delay: 0.4, ease: "easeInOut" }}
        className="mt-9 h-px w-44 origin-left bg-gradient-to-r from-brand to-transparent"
      />
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.7 }}
        className="mt-5 font-tech text-[10px] uppercase tracking-[0.5em] text-slate-500"
      >
        Electronic Infrastructure
      </motion.p>
    </motion.div>
  );
}
